import { render, staticRenderFns } from "./NouvellePartie.vue?vue&type=template&id=0523c954&"
import script from "./NouvellePartie.vue?vue&type=script&lang=js&"
export * from "./NouvellePartie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports